export const environment = {
  version : "1.3.1",
  googleApiKey : "AIzaSyAQG5h2J0w8ioV-oi8uRJxerSNvZGNxrW4", 
  production: true,
  username: "",
  role: "",
  host:  {
    domaine: "https://extranet-vendeur-realestate.bnpparibas.fr/api",
    domaineEchonet: "https://api.resi-realestate.is.echonet",
    serviceOptions:'',
    url_keycloak: 'https://extranet-vendeur-realestate.bnpparibas.fr/realms/',
    realm_keycloak: 'RESI-APIS',
    clientId_keycloak: 'extranet-angular'
    }
};

